import React, { Suspense, lazy } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";

// Loading component for suspense fallback
const PageLoader = () => (
  <div style={{
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100vh',
    background: 'linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 100%)'
  }}>
    <div style={{
      textAlign: 'center',
      color: '#b8a07a'
    }}>
      <div style={{
        width: '40px',
        height: '40px',
        border: '3px solid #b8a07a',
        borderTopColor: 'transparent',
        borderRadius: '50%',
        animation: 'spin 1s linear infinite',
        margin: '0 auto 16px'
      }} />
      <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
      <p style={{ fontSize: '14px', letterSpacing: '2px' }}>LOADING...</p>
    </div>
  </div>
);

// Lazy load public pages (most important for initial load)
const LandingPage = lazy(() => import("./pages/LandingPage"));
const TeamOutingsPage = lazy(() => import("./pages/TeamOutingsPage"));
const YellowMoonPage = lazy(() => import("./pages/YellowMoonPage"));
const WeddingsPage = lazy(() => import("./pages/WeddingsPage"));

// Lazy load admin pages (only loaded when needed)
const AdminLogin = lazy(() => import("./pages/admin/AdminLogin"));
const AdminLayout = lazy(() => import("./pages/admin/AdminLayout"));
const AdminDashboard = lazy(() => import("./pages/admin/AdminDashboard"));
const AdminInquiries = lazy(() => import("./pages/admin/AdminInquiries"));
const AdminVenue = lazy(() => import("./pages/admin/AdminVenue"));
const AdminContent = lazy(() => import("./pages/admin/AdminContent"));
const AdminPerformance = lazy(() => import("./pages/admin/AdminPerformance"));
const AdminTeamOutingsContent = lazy(() => import("./pages/admin/AdminTeamOutingsContent"));
const AdminTeamOutingsPricing = lazy(() => import("./pages/admin/AdminTeamOutingsPricing"));
const AdminTeamOutingsProforma = lazy(() => import("./pages/admin/AdminTeamOutingsProforma"));
const AdminTeamOutingsAnalytics = lazy(() => import("./pages/admin/AdminTeamOutingsAnalytics"));
const AdminTeamOutingsAvailability = lazy(() => import("./pages/admin/AdminTeamOutingsAvailability"));
const AdminTeamOutingsMedia = lazy(() => import("./pages/admin/AdminTeamOutingsMedia"));
const AdminYellowMoonAvailability = lazy(() => import("./pages/admin/AdminYellowMoonAvailability"));
const AdminLeads = lazy(() => import("./pages/admin/AdminLeads"));
const AdminCMS = lazy(() => import("./pages/admin/AdminCMS"));
const AdminCoupons = lazy(() => import("./pages/admin/AdminCoupons"));
const AdminPaymentSettings = lazy(() => import("./pages/admin/AdminPaymentSettings"));
const AdminOffers = lazy(() => import("./pages/admin/AdminOffers"));
const AdminVenues = lazy(() => import("./pages/admin/AdminVenues"));

function App() {
  return (
    <div className="App">
      <Toaster position="top-right" richColors />
      <BrowserRouter>
        <Suspense fallback={<PageLoader />}>
          <Routes>
            {/* Public Routes */}
            <Route path="/" element={<LandingPage />} />
            <Route path="/kai" element={<TeamOutingsPage />} />
            <Route path="/yellow-moon" element={<YellowMoonPage />} />
            <Route path="/weddings" element={<WeddingsPage />} />
            {/* Legacy route redirect */}
            <Route path="/team-outings" element={<Navigate to="/kai" replace />} />
            
            {/* Admin Routes */}
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminLayout />}>
              <Route index element={<AdminDashboard />} />
              <Route path="inquiries" element={<AdminInquiries />} />
              <Route path="venue" element={<AdminVenue />} />
              <Route path="content" element={<AdminContent />} />
              <Route path="performance" element={<AdminPerformance />} />
              <Route path="leads" element={<AdminLeads />} />
              <Route path="cms" element={<AdminCMS />} />
              <Route path="coupons" element={<AdminCoupons />} />
              <Route path="payments" element={<AdminPaymentSettings />} />
              <Route path="offers" element={<AdminOffers />} />
              <Route path="venues" element={<AdminVenues />} />
              {/* Team Outings Admin (KAI) */}
              <Route path="team-outings/content" element={<AdminTeamOutingsContent />} />
              <Route path="team-outings/pricing" element={<AdminTeamOutingsPricing />} />
              <Route path="team-outings/proforma" element={<AdminTeamOutingsProforma />} />
              <Route path="team-outings/analytics" element={<AdminTeamOutingsAnalytics />} />
              <Route path="team-outings/availability" element={<AdminTeamOutingsAvailability />} />
              <Route path="team-outings/media" element={<AdminTeamOutingsMedia />} />
              {/* Yellow Moon Admin */}
              <Route path="yellow-moon/availability" element={<AdminYellowMoonAvailability />} />
            </Route>
          </Routes>
        </Suspense>
      </BrowserRouter>
    </div>
  );
}

export default App;
